//Loading Indicators Reducer


const loadingReducerDefaultState = {
    isLoadingData : false,
    noSelected    : false,
    noCheckbox    : false
};

export default (state = loadingReducerDefaultState, action) => {
    switch(action.type) {
        case 'SET_LOADING_INDICATOR':
            return {
                ...state,
                isLoadingData : action.isLoadingData
            };
        case 'NO_SELECT_ERROR':
            return {
                ...state,
                noSelected : action.noSelected
            };
        case 'NO_CHECKBOX_SELECTED_ERROR':
            return {
                ...state,
                noCheckbox : action.noCheckbox
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/Reducers/loading.js